import type { FC } from 'react';
import { useCallback } from 'react';
import cx from 'classnames';

import type {
	EnquiriesSearchStoreState,
	EnquiriesSelectStoreState,
	EnquiriesStoreState,
} from 'Features/SellerCommunications/services';
import { triggerSellerMessagingSelectSellerCheckboxClickedEvent } from 'Services/analytics/events';

import { ModalEnquiryListCheckbox } from './ModalEnquiryListCheckbox';
import { ModalEnquiryListItem } from './ModalEnquiryListItem';

import styles from './ModalEnquiryList.module.scss';

interface ModalModalEnquirySelectListItemsProps {
	enquiries: EnquiriesStoreState['enquiries'];
	filteredSaleIds?: EnquiriesSearchStoreState['filteredSaleIds'];
	interactedSaleIds?: EnquiriesSelectStoreState['interactedSaleIds'];
	onToggle: (saleId: string) => void;
}

export const ModalEnquirySelectListItems: FC<ModalModalEnquirySelectListItemsProps> = ({
	enquiries,
	filteredSaleIds,
	interactedSaleIds,
	onToggle,
}) => {
	const handleToggle = useCallback(
		(saleId: string, enquiryId: string, isChecked: boolean) => {
			onToggle?.(saleId);
			triggerSellerMessagingSelectSellerCheckboxClickedEvent({
				enquiryId,
				isChecked,
			});
		},
		[onToggle],
	);

	return (
		<>
			{enquiries.map((enquiry) => (
				<div
					key={`${enquiry.saleId}`}
					className={cx(styles.item, { [styles.hide]: filteredSaleIds?.[enquiry.saleId] === false })}
				>
					<ModalEnquiryListCheckbox
						checked={Boolean(interactedSaleIds?.[enquiry.saleId])}
						enquiryId={enquiry.enquiryId}
						onToggle={handleToggle}
						saleId={enquiry.saleId}
					/>
					<ModalEnquiryListItem
						enquiryId={enquiry.enquiryId}
						leadPhoto={enquiry.leadPhoto}
						make={enquiry.make}
						model={enquiry.model}
						saleId={enquiry.saleId}
						slug={enquiry.state.slug}
						vrm={enquiry.vrm}
					/>
				</div>
			))}
		</>
	);
};
